import { render, staticRenderFns } from "./KzsTemplatesView.vue?vue&type=template&id=41073787"
import script from "./KzsTemplatesView.vue?vue&type=script&lang=js"
export * from "./KzsTemplatesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports